import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { HasClassName } from '../../component-utils';
import { useSelector } from '../../hook-utils';
import { InstantMessagerJoinState, Media } from '../../model';
import { actions } from '../../store';
import { getConfig } from '../../store/reducers/config';
import { getInstantMessageById } from '../../store/reducers/instantmessager';
import { InstantMessagerView } from '../IM/InstantMessagerView';
import './ChatView.scss';

interface Props extends HasClassName {
  media: Media
}

export default function ChatViewRoot({ className, media }: Props) {
  const config = useSelector(getConfig)
  const conversation = useSelector(s => getInstantMessageById(s, media.mediaItemId))
  const dispatch = useDispatch()
  const isAlreadyJoined = conversation && conversation.joined === InstantMessagerJoinState.joined
  useEffect(() => {
    if (!config || isAlreadyJoined) return

    dispatch(actions.joinQueuedInstantmessage(media.mediaItemId))
  }, [config, dispatch, isAlreadyJoined, media.mediaItemId])

  if (!conversation) return <></>

  return <div className='ChatView'>
    <InstantMessagerView id={media.mediaItemId} />
  </div>
}


